import { SET_WELCOME_DATA, SET_WELCOME_INIT } from '../constants/welcome';

const initState = {
  welcomeData: null,
  init: false,
};

const Welcome = (state = initState, action = {}) => {
  switch (action.type) {
    case SET_WELCOME_DATA:
      return {
        ...state,
        welcomeData: {
          ...state.welcomeData,
          ...action.payload,
        },
      };
    case SET_WELCOME_INIT:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default Welcome;
